import React from 'react';
import _ from 'lodash';
import Button from '../../Layout/Button';
import { riskValueTransform } from '../../../containers/RiskManagement/Configuration/SportTemplates/utils';

export const SportTemplatesRow = ({
  tableData,
  editHandler,
  showDeleteModal,
  sportViews
}) => {
  const renderRow = data => {
    const { sportId, categoryId, tournamentId } = _.pick(data.template, [
      'sportId',
      'categoryId',
      'tournamentId'
    ]);
    let sportName = '',
      categoryName = '',
      tournamentName = '';

    if (tournamentId) {
      const sportView = sportViews.find(
        sportView => sportView.tournamentId === tournamentId
      );
      tournamentName = sportView.tournamentName;
      categoryName = sportView.categoryName;
      sportName = sportView.sportName;
    } else if (categoryId) {
      const sportView = sportViews.find(
        sportView => sportView.categoryId === categoryId
      );
      categoryName = sportView.categoryName;
      sportName = sportView.sportName;
    } else if (sportId) {
      const sportView = sportViews.find(
        sportView => sportView.sportId === sportId
      );
      sportName = sportView.sportName;
    }

    return (
      <tr key={data.id}>
        <td>{data.name}</td>
        <td>{tournamentName}</td>
        <td>{categoryName}</td>
        <td>{sportName}</td>
        <td>{riskValueTransform(data.riskControlParameters, 'MAX_TAKEOUT')}</td>
        <td>
          <Button
            onClick={() => editHandler(data)}
            cssClass="btn btn-outline-secondary btn-xs mr-1"
          >
            <i className="fas fa-edit" /> Edit
          </Button>
          <Button
            onClick={() => showDeleteModal(data)}
            cssClass="btn btn-danger btn-xs"
          >
            <i className="fas fa-trash" /> Delete
          </Button>
        </td>
      </tr>
    );
  };

  return (
    <>
      {tableData.length !== 0 ? (
        tableData.map(renderRow)
      ) : (
        <tr>
          <td>No transactions found.</td>
        </tr>
      )}
    </>
  );
};

export default SportTemplatesRow;
